export default __webpack_public_path__ + "static/media/gdpr_policy_PFM_LINK.63fa8f10.pdf";